export function calcCountPages(response, limit = process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION){
  try {
    return Math.ceil(response.data.count / limit);
  } catch(error){
    return 0;
  }  
}

export function calcOffset(page, limit = process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION){
  try {
    return  (page - 1) * limit;
  } catch(error){
    return 0;
  }  
}